import styled from 'styled-components';
import {
  bordersColor,
  complementaryColor,
  darkGrayColor,
  notificationErrorColor,
  primaryColor,
} from '../constants/colors';
import {mediaMinTablet} from '../constants/customMedia';
import {fsXS, fsXXS, fwBold, fwMediumBold} from '../constants/typography';

export const CancelButton = styled.button`
  width: 121px;
  height: 48px;
  border-radius: 2px;
  border: solid 1px ${bordersColor};
  background-color: ${complementaryColor};
  text-align: center;
  color: ${primaryColor};
`;

export const EditButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 2px;
  background-color: ${primaryColor};
  text-align: center;
  color: ${complementaryColor};
  border: none;
`;

export const SaveButton = styled.input`
  width: auto;
  height: 48px;
  border-radius: 2px;
  background-color: ${primaryColor};
  text-align: center;
  color: ${complementaryColor};
  border: none;
`;

export const Content = styled.div`
  padding: 30px 16px;
`;

export const DisclaimerText = styled.div`
  font-size: ${fsXXS}px;
  ${fwMediumBold};
  line-height: 1.5;
  color: ${darkGrayColor};
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 10px;
  & ~ & {
    margin-bottom: 0;
  }
`;

export const DeleteBankData = styled.button`
  margin-top: 20px;
  border: none;
  padding: 0;
  font-size: ${fsXS}px;
  line-height: 1.29;
  text-align: center;
  color: ${notificationErrorColor};
  background-color: ${complementaryColor};
  ${fwBold}

  @media ${mediaMinTablet} {
    width: auto;
    cursor: pointer;
    border: 0;
    text-align: left;
    padding-left: 0;
  }
`;

export const DeletePopUp = styled.div`
  height: 176px;
  border-radius: 6px;
  box-shadow: 0 50px 75px 0 rgba(0, 0, 0, 0.1), 0 2px 30px 0 rgba(0, 0, 0, 0.02);
  background-color: ${complementaryColor};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .delete-pop-up {
    padding: 25px 0px 0px;
  }
`;

export const ConfirmDelete = styled.button`
  width: 131px;
  height: 48px;
  border-radius: 2px;
  background-color: ${notificationErrorColor};
  color: ${complementaryColor};
  font-size: ${fsXS}px;
  font-weight: 700;
  line-height: 1.29;
  border: none;
  margin-left: 10px;

  @media ${mediaMinTablet} {
    cursor: pointer;
  }
`;

export const BankDetailsFooter = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
  padding-top: 0;
`;
